<div id="fn-multi-time-picke">
  <div class="fn-time-picker-search">
    <input class="form-control" [(ngModel)]="searchTerm" (click)="openDropDown($event)"
      (keydown)="keyDownChange($event)" maxlength="17" (keyup)="filterValue($event)" [disabled]="isDisabled"
      [placeholder]="placeHolder" />
    @if (uiItemArray.length > 0 && showDropDown) {
    <ul class="fn-time-picker-ul" [fnAppendTo]="appendTo" (outsideClick)="closeDropDown()">
      @for (item of uiItemArray; track item; let i = $index) {
      <li tabindex="{{i}}" [ngClass]="{'active': activeIndex === i  }" (click)="onItemClick(item)">{{item}}</li>
      }
    </ul>
    }
  </div>
</div>